<!-- //群聊模板 -->
<template>
  <div v-if="selectedAccountFriendId">
    <div style="position: relative">
      <div class="ntMain__head">
        <div class="header_c">
          <div class="left">
            <div class="avatar">
              <img :src="chatingFriendInfo.avatar" />
            </div>
            <div class="name">
              <div v-if="chatModel == 1">
                <el-space :size="5" spacer="|">
                  <div style="height: 25px" class="flex_center">
                    {{ chatingFriendInfo.title }}
                  </div>
                  <div style="height: 25px" class="flex_center">
                    <img
                      src="@assets/adicon/tencent.png"
                      v-if="chatingAccount.account_type == 36"
                      style="width: 20px; height: 20px" />
                    <img
                      src="@assets/adicon/baidu.png"
                      v-else-if="chatingAccount.account_type == 37"
                      style="width: 18px; height: 18px" />
                    <i
                      class="iconfont icon-weixinxiaodian m_color_wxstore"
                      v-else-if="chatingAccount.account_type == 9"></i>
                    <i
                      class="iconfont"
                      v-else
                      :class="[
                        smartEnumPlugin.getEnumItemByValue('PLAT_TYPE_MENU_TOOL', chatingPlatId)
                          ?.icon,
                        smartEnumPlugin.getEnumItemByValue('PLAT_TYPE_MENU_TOOL', chatingPlatId)
                          ?.colorClass,
                      ]"></i>
                    <span class="m_color_2">
                      {{ chatingAccount?.username }}
                    </span>
                    <div
                      class="m_border_r m_desc overflow_ellipsis"
                      style="margin-left: 3px; font-size: 11px; padding: 0 3px">
                      {{
                        $syscfgNameByValue("customer_type_list", chatingAccount.customer_type_id)
                      }}
                    </div>
                  </div>
                </el-space>
              </div>
              <!-- 控制台模式 -->
              <div v-else>
                <el-space :size="5" spacer="|">
                  <div style="height: 25px" class="flex_center">
                    {{ chatingFriendInfo.title }}
                  </div>
                  <div style="height: 25px" class="flex_center">
                    <img
                      src="@assets/adicon/tencent.png"
                      v-if="chatingFriendInfo.account_type == 36"
                      style="width: 20px; height: 20px" />
                    <img
                      src="@assets/adicon/baidu.png"
                      v-else-if="chatingFriendInfo.account_type == 37"
                      style="width: 18px; height: 18px" />
                    <i
                      class="iconfont icon-weixinxiaodian m_color_wxstore"
                      v-else-if="chatingFriendInfo.account_type == 9"></i>
                    <i
                      class="iconfont"
                      v-else
                      :class="[
                        smartEnumPlugin.getEnumItemByValue(
                          'PLAT_TYPE_MENU_TOOL',
                          chatingFriendInfo.plat_type,
                        )?.icon,
                        smartEnumPlugin.getEnumItemByValue(
                          'PLAT_TYPE_MENU_TOOL',
                          chatingFriendInfo.plat_type,
                        )?.colorClass,
                      ]"></i>
                    <span class="m_color_2">
                      {{ chatingFriendInfo?.account_nickname }}
                    </span>
                    <div
                      class="m_border_r m_desc overflow_ellipsis"
                      style="margin-left: 3px; font-size: 11px; padding: 0 3px">
                      {{
                        $syscfgNameByValue("customer_type_list", chatingFriendInfo.customer_type_id)
                      }}
                    </div>
                  </div>
                </el-space>
              </div>
            </div>
            <!-- <el-tag type="primary">已加载消息({{ allMsgCount }})</el-tag> -->
          </div>

          <div class="right">
            <el-button
              size="small"
              :class="{
                active_right_comp: activeComponent.component_item == 'chatingCustomInfo',
              }"
              @click="handleActiveSidebarRightComponent('chatingCustomInfo')">
              <el-tooltip content="好友信息" effect="light" placement="right">
                <div class="l_item_tip" style="">
                  <i class="iconfont icon-person"></i>
                </div>
              </el-tooltip>
            </el-button>
            <el-button
              size="small"
              :class="{
                active_right_comp: activeComponent.component_item == 'customChatlogHistory',
              }"
              @click="handleActiveSidebarRightComponent('customChatlogHistory')">
              <el-tooltip content="聊天记录" effect="light" placement="right">
                <div class="l_item_tip">
                  <i class="iconfont icon-rizhi"></i>
                </div>
              </el-tooltip>
            </el-button>
          </div>
        </div>
      </div>
      <div style="box-sizing: border-box; position: absolute; width: 100%; text-align: center">
        <div v-if="fetchingChatLogFriendId == selectedAccountFriendId">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <span style="color: #9ea0a3; font-size: 11px; display: inline-block; margin-left: 10px">
            最新消息加载中...
          </span>
        </div>
        <div v-else style="display: flex; justify-content: center">
          <el-button
            v-if="!showComment"
            :disabled="chatLogNoMore"
            link
            type="primary"
            @click="handleLoadMore"
            style="font-size: 11px; cursor: pointer; z-index: 999">
            加载更多>>
          </el-button>
        </div>
      </div>
    </div>

    <!-- 评论列表 -->
    <div style="height: 200px; position: relative" v-if="showComment" class="flex1 p_10">
      <div
        v-if="commentListRef.length == 0"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          font-weight: 600;
          font-size: 20px;
          color: #9ea0a3;
        ">
        <el-skeleton :rows="5" animated v-if="commentLoading" />
        <div v-else>
          <i
            class="iconfont icon-datagrid-no-data"
            style="font-size: 50px; color: #9ea0a3; margin-right: 10px"></i>
          <div>评论为空~</div>
        </div>
      </div>

      <el-scrollbar ref="scrollRef" v-else>
        <div v-for="(item, index) in commentListRef" :key="item.id">
          <commentitem :comment="item" :index="index" @replyComment="handleShowReplyComment" />
        </div>
      </el-scrollbar>
    </div>
    <!-- 消息列表 -->
    <div
      v-else
      style="height: 200px; position: relative"
      class="ntMain__cont flex1 flexbox flex-col"
      @dragenter="handleDragEnter"
      @dragover="handleDragOver"
      @drop="handleDrop">
      <!-- <v3-scroll ref="scrollRef" autohide> -->
      <el-scrollbar ref="scrollRef" @scroll="handleScroll">
        <div ref="innerRef" class="vChatMsg-cnt">
          <div
            style="text-align: center; color: #9ea0a3; font-size: 11px"
            v-if="friendChatLog.msglist?.length === 0 && fetchingChatLogFriendId == 0">
            ----- 没有消息哦 -----
            <br />
            我们友谊从您的第一句招呼开始
          </div>
          <ul class="clearfix">
            <li
              v-for="(item, index) in showChatLogList"
              :key="(item.id || '') + (item.s_uuid || '')">
              <messageItem
                :msgItem="item"
                :upMsgTime="handleFindUpMsgTime(index)"
                @read-status-change="handleMsgReadStatusChange" />
            </li>
          </ul>
        </div>
        <!-- </v3-scroll> -->
      </el-scrollbar>
    </div>
    <div class="vChat__footTool" style="height: 200px; z-index: 999">
      <div class="vChat__editor-panel flexbox flex-col" style="height: 100%">
        <div class="wrap-toolbar">
          <div class="flexbox">
            <div class="flex1">
              <i class="btn iconfont icon-emoj" title="选择表情" @click.stop="handleEmojView"></i>
              <i
                class="btn iconfont icon-tupian"
                title="发送图片"
                @click="handleChooseImageVisiable"></i>
              <i
                class="btn iconfont icon-zhuanshuqiyemingpian"
                title="名片"
                @click="handleShowCardPage"></i>
              <i
                v-if="chatingPlatId == 1"
                class="btn iconfont icon-yijianqujian"
                title="卡片"
                @click="handleShowOnekeyLeads"></i>

              <!-- 人工接管 -->
              <el-popover placement="top-start" width="300" trigger="hover">
                <div style="min-height: 50px; font-size: 12px">
                  <div class="m_desc m_border_b" style="margin-bottom: 10px">
                    <h3 class="m_color_2">点击切换人工接管状态</h3>
                    <h4 class="m_color_2">
                      请注意：人工接管开启后，如果离开当前会话(点击其它好友)，{{
                        userInfo?.artificial_active_time || 60
                      }}秒后【自动关闭】当前好友的人工接管状态
                    </h4>
                    <p class="m_color_s1">
                      1.人工接管状态如果【开启】：Ai消息(如果AI启用)，追粉消息和欢迎语【
                      <span style="font-weight: bold">不会</span>
                      发送】
                    </p>
                    <p class="m_color_e">
                      2.人工接管状态如果【关闭】：Ai消息(如果AI启用)，追粉消息和欢迎语【
                      <span style="font-weight: bold">正常</span>
                      发送】
                    </p>
                  </div>
                  <div v-if="chatingFriendInfo.is_artificial === 1">
                    人工接管状态：
                    <span class="m_color_s1">开启</span>
                  </div>
                  <div v-else>
                    人工接管状态：
                    <span class="m_color_e">关闭</span>
                  </div>
                </div>
                <template #reference>
                  <i
                    @click="
                      handleChangeManuStatus(
                        chatingFriendInfo?.cid,
                        chatingFriendInfo.is_artificial,
                      )
                    "
                    class="btn iconfont icon-male"
                    :class="{ m_color_s22: chatingFriendInfo.is_artificial === 1 }"></i>
                </template>
              </el-popover>

              <!-- 评论 -->
              <div
                style="display: inline-block; position: relative"
                v-if="chatingFriendInfo.comment_num > 0">
                <img
                  v-if="!showComment"
                  :src="require('@assets/img/comment.png')"
                  class="btn"
                  style="width: 20px; height: 21px"
                  title="点击查看评论消息"
                  @click.stop="handdleShowComment" />
                <i
                  v-else
                  class="iconfont icon-shuohuaspeak1 btn"
                  title="点击查看私信"
                  @click.stop="handdleShowComment"></i>
              </div>

              <!-- <i class="btn iconfont icon-pinglun" title="评论/消息，点击切换(暂无评论)" @click="handleChooseImageVisiable"></i> -->

              <!-- 图片预览 -->
              <el-dialog
                v-model="preview"
                class="image-preview"
                :before-close="handleClearUploadInfo"
                width="60%"
                top="10vh"
                @open="initUploadDivListener"
                :z-index="99999">
                <div>
                  <el-upload
                    :on-exceed="handleExceed"
                    :limit="1"
                    v-model:file-list="uploadFileList"
                    drag
                    :action="qiniuUploadurl"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :on-change="handleChooseImage0"
                    :before-upload="handleUploadBefore"
                    :on-progress="hadleUploadProgress"
                    :accept="pictureType"
                    ref="uploadPictureRef"
                    style="display: inline-block; width: 100%"
                    :data="uploadImageData">
                    <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                    <div class="el-upload__text">
                      拖拽文件到此处或
                      <em>点击此处上传</em>
                    </div>
                  </el-upload>
                </div>

                <div
                  style="
                    height: 200px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  <div
                    style="
                      border: 1px dashed red;
                      width: 100%;
                      height: 100%;
                      position: relative;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    支持
                    <em style="color: #3dbb51">截屏粘贴图片</em>
                    到此处上传
                    <div
                      style="position: absolute; top: 0; background-color: rgba(0, 0, 0, 0.1)"
                      ref="uploadImageDivRef"
                      @keydown="handleUploadImageDivInput"
                      class="editor_div"
                      v-html="uploadImageText"
                      contentEditable="true"></div>
                  </div>
                </div>

                <div style="display: flex; justify-content: center; margin-top: 10px">
                  <el-button type="primary" v-loading="imageSendLoading" @click="handleSendImage">
                    发送
                  </el-button>
                  <el-button @click="handleClearUploadInfo">取消</el-button>
                </div>
              </el-dialog>
            </div>
            <i
              class="btn iconfont icon-gonggao"
              title="点击查看快捷键"
              @click="handleTipsLayer"></i>
          </div>

          <div v-show="showEmojView" class="wrap-emojPanel" @click.stop>
            <div class="wrap-emojbox">
              <div class="emoj__cells">
                <v3-scroll size="5">
                  <div>
                    <div v-if="chatingPlatId == 2" :class="'face__sm_list'">
                      <div v-for="(item, index) in xhsemojList" :key="index" class="item">
                        <img
                          :src="getXshFileAbsPath(item.file)"
                          class="face"
                          @click.stop="handleAddFace(item)" />
                      </div>
                    </div>
                    <div v-else :class="'face__sm_list'">
                      <div v-for="(item, index) in emojList" :key="index" class="item">
                        <img
                          :src="require('@assets/img/emoji/' + item.file)"
                          class="face"
                          @click.stop="handleAddFace(item)" />
                        <!-- <img
                          v-else
                          :src="item2"
                          @click="handleEmojGifClicked(item2)"
                        /> -->
                      </div>
                    </div>
                  </div>
                </v3-scroll>
              </div>
            </div>
          </div>
        </div>
        <div class="wrap-editor flex1">
          <textarea
            ref="editorRef"
            @keydown="handleOnKeyup"
            v-model="editorText"
            @blur="handleSaveFocusIndex"
            name="textarea"
            style="width: 100%; height: 100%; border: none"
            maxlength="1024"
            @keydown.enter="handleMsgTextEvent($event)"></textarea>
        </div>

        <el-button
          v-if="
            (chatingAccount?.end_flg === 1 || chatingAccount?.end_flg === -1) && chatingPlatId == 1
          "
          type="danger"
          :disabled="true">
          【{{ chatingAccount.username }}】的端口已过期或未绑定无法发送信息
        </el-button>
        <button v-else class="btn-submit" :disabled="isSubmitDisabled" @click="handleSubmit">
          发送(S)
        </button>
      </div>
    </div>

    <!-- 企业名片选择 -->
    <enterpriseCard ref="enterpriseCardRef" @sendCard="handleSendCard" />
    <!-- 一键留资 -->
    <onekeyleads ref="onekeyleadsRef" @sendOneKeyCard="handleSendOneKeyCard" />
    <!-- 评论回复 -->
    <messageInput ref="messageInputRef" :nullable="false" @contentResult="handleReplyComment" />
  </div>
</template>
<script>
import {
  onMounted,
  ref,
  reactive,
  toRefs,
  watch,
  nextTick,
  inject,
  computed,
  onUnmounted,
  provide,
} from "vue";
import { useRoute } from "vue-router";
// import Editor from "./editor.vue";
// import SendRedPacket from "./redPacket.vue";
// import GroupSet from "./groupInfo.vue";
import { useStore } from "vuex";
import messageItem from "@/views/components/messageItem.vue";
import enterpriseCard from "@/components/enterprisecard/index.vue";
import onekeyleads from "@/components/onekeyleads/index.vue";
import { getFriendChatLog, notifyFriendMsgReaded, getFriendClue, sendMsg } from "@/api/chatapi";
import { getFriendCommentList, replyComment } from "@/api/commentapi";
import { v4 as uuidv4 } from "uuid";
// const emoJSON = require("./mock/emoj.js");
import { emojis } from "@/utils/emoji-util";
import { xhsemojis, getXshFileAbsPath } from "@/utils/xhs-emoji-util";
//const msgJSON = require("@/mock/recordlist.js");
// import ImagePreview from './components/ImagePreview'
import { ElMessage } from "element-plus";
import { UploadFilled } from "@element-plus/icons-vue";
import { changeFriendAiStatus } from "@/api/aichatapi";
import securityUtils from "@/utils/securityutils";
import commentitem from "@/components/commentitem/index.vue";
import messageInput from "@/components/message-input/index.vue";
const DEFAULT_SHOW_NUM = 50;
const FETAH_SIZE = 50;
const READ_RECEIPT_BACKFILL_LIMIT = 10;
export default {
  components: { messageItem, UploadFilled, enterpriseCard, onekeyleads, commentitem, messageInput },
  setup() {
    const innerRef = ref(null);
    const scrollRef = ref(null);
    const uploadPictureRef = ref(null);
    const editorRef = ref(null);
    const uploadImageDivRef = ref(null);
    const pickImageRef = ref(null);
    const pickVideoRef = ref(null);
    const playerRef = ref(null);
    const route = useRoute();
    const v3layer = inject("v3layer");
    const bus = inject("$eventBus");
    const allMsgCount = ref(0);
    const showMsgCount = ref(DEFAULT_SHOW_NUM);
    const isBackfillingReadStatus = ref(false);

    const wsCmd = inject("wsCmd");
    const eventbusCms = inject("eventbusCms");
    const chatlogstore = inject("chatlogstore");
    const smartEnumPlugin = inject("smartEnumPlugin");
    let store = useStore();
    const userInfo = computed(() => {
      return store.state.user.user;
    });

    //是否显示评论
    const showComment = ref(false);
    const commentListRef = ref([]);
    const messageInputRef = ref(undefined);
    const commentLoading = ref(false);

    const data = reactive({
      focusIndex: 0, // 光标在文本的位置
      editorText: "",
      showEmojView: false,
      isSubmitDisabled: true,
      emojList: emojis,
      xhsemojList: xhsemojis,
      groupLs: null,
      // 视频播放器
      isShowVideoPlayer: false,
      videoList: [],
      // 開红包弹窗
      isShowRedPacket: false,
      redPacketList: [],
      // 发送红包弹窗
      isShowSendRedPacketLayer: false,
      // 群设置
      isShowGroupSetLayer: false,
      //聊天信息
      friendChatLogData: { fid: 0, aid: 0, msglist: [] },
      //消息滚动条滚动到顶部
      scrollToTop: false,
      //没有更多消息
      chatLogNoMore: false,
      //图片预览
      preview: false,
      previewImg: "",
      //1图片
      previewType: 1,
      progress: 100,
      pictureType: ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
      // 最大图片上传尺寸
      maxPictureSize: 2,
      //图片发送加载
      imageSendLoading: false,
      //图片上传内容
      uploadImageText: "",
      uploadFileList: [],
    });

    const qiniuUploadurl = computed(() => {
      return store.state.qiniu.uploadurl;
    });

    // 激活显示的右侧组件
    const activeComponent = computed(() => {
      return store.state.sidebarRight.activeComponent;
    });

    const enterpriseCardRef = ref(undefined);

    // 一键留资
    const onekeyleadsRef = ref(undefined);

    onUnmounted(() => {
      //注册监听事件start---
      bus.off(`${wsCmd.cmd_4_resp}`); // listen
      bus.off(`${wsCmd.cmd_6_resp}`); // listen
      bus.off(eventbusCms.selectFriendChange); // listen
      bus.off(eventbusCms.sendFriendMsg);
      bus.off(`${wsCmd.cmd_37_resp}`); // listen
      //注册监听事件end---
    });

    onMounted(() => {
      //注册监听事件start---
      bus.on(`${wsCmd.cmd_4_resp}`, receiveFrindChatLog); // listen
      bus.on(`${wsCmd.cmd_6_resp}`, receiveFrindChatLog); // listen
      bus.on(eventbusCms.selectFriendChange, onSelectFriendChange); // listen
      bus.on(eventbusCms.sendFriendMsg, handleSendMessage);
      //预发送消息
      bus.on(eventbusCms.preSendFriendMsg, handlePreSendMessage);
      //评论列表
      bus.on(`${wsCmd.cmd_37_resp}`, handleReceiveCommentList); // listen
      //注册监听事件end---
      let cid = route.query.id;
      if (cid) {
        initAndFetchChatLog(cid);
      }
    });
    watch(route, (newRoute, oldRoute) => {
      let cid = newRoute.query.id;
      if (cid) {
        commentListRef.value = [];
        showComment.value = false;
      }
    });
    watch(
      () => data.editorText,
      () => {
        if (isEmpty(data.editorText)) {
          data.isSubmitDisabled = true;
        } else {
          data.isSubmitDisabled = false;
        }
      },
    );
    //回复评论
    const handleReplyComment = async (replyMsg) => {
      let { content, echo } = replyMsg;
      let data = {
        fid: selectedAccountFriendId.value,
        msgtype: 3,
        log_id: echo || "",
        msg: content,
      };
      replyComment(data);
    };
    //显示回复评论
    const handleShowReplyComment = async (commentId) => {
      if (!commentId) {
        return;
      }
      messageInputRef.value.show(chatingPlatId.value, commentId);
    };
    //显示评论
    const handdleShowComment = async () => {
      showComment.value = !showComment.value;
      if (!showComment.value) {
        return;
      }
      let data = {
        fid: selectedAccountFriendId.value,
        limit: 100,
      };
      commentLoading.value = true;
      getFriendCommentList(data);
    };
    //评论列表数据返回
    const handleReceiveCommentList = async (resp) => {
      commentLoading.value = false;
      let code = resp?.code;
      if (code != 1) {
        return;
      }
      let data = resp?.data || {};
      let fid = data?.fid || 0;
      if (fid != selectedAccountFriendId.value) {
        return;
      }
      let msgList = data?.msglist || [];
      let type = resp.type;
      if (type == 1) {
        commentListRef.value = msgList;
      } else if (type == 3) {
        //更新评论信息
        if (msgList.length > 0) {
          let commentItem = msgList[0];
          let commentItemId = commentItem?.id || 0;
          if (commentItemId > 0) {
            let finIdx = commentListRef.value.findIndex((item) => item.id == commentItemId);
            if (finIdx == -1) {
              commentListRef.value.unshift(commentItem);
            } else {
              let findItem = commentListRef.value[finIdx];
              //更新
              findItem = Object.assign(findItem, commentItem);
              commentListRef.value.splice(finIdx, 1, findItem);
            }
          }
        }
      }
    };

    //显示名片选择窗口
    const handleShowCardPage = async () => {
      enterpriseCardRef.value.show();
    };
    //显示一键留资选择窗口
    const handleShowOnekeyLeads = async () => {
      onekeyleadsRef.value.show();
    };
    //开启好友AI接管
    const handleStartAi = (chatFriendId) => {
      if (!chatFriendId) {
        return;
      }
      let param = { fid: chatFriendId, is_artificial: 0 };
      changeFriendAiStatus(param);
    };

    // 停止好友AI接管
    const handleChangeManuStatus = (chatFriendId, status) => {
      if (!chatFriendId) {
        return;
      }
      let _status = status === 1 ? 0 : 1;
      let param = { fid: chatFriendId, is_artificial: _status };
      changeFriendAiStatus(param);
    };

    const handleUseRobotStatusChange = () => {};
    //加载更多
    const handleLoadMore = () => {
      //获取最小的记录ID
      let minId = getMinChatLogId(showChatLogList.value);
      store.commit("chat_store/setFetchingChatLogFriendId", selectedAccountFriendId.value);
      getFriendChatLog({
        fid: selectedAccountFriendId.value, //好友id
        limit: FETAH_SIZE, //返回记录数，默认20
        log_id: minId, //上页记录id
      });
      showMsgCount.value = showMsgCount.value + FETAH_SIZE;
    };

    //消息滚动条滚动事件处理
    const handleScroll = (e) => {
      //暂时不处理滚动刷新事件
      let i = 1;
      if (i == 1) {
        return;
      }

      let scrollTop = e.scrollTop;
      //滚动到顶部加载上一页
      if (scrollTop == 0 && data.chatLogNoMore == false) {
        data.scrollToTop = true;
        //获取最早一条聊天记录ID
        //本地数据
        let localData = chatlogstore.getChatLog(selectedAccountFriendId.value);
        let minId = 0;
        if (localData && localData.msglist?.length > 0) {
          minId = getMinChatLogId(localData.msglist);
        }
        //当前聊天数据
        if (data.friendChatLogData.msglist && data.friendChatLogData.msglist.length > 0) {
          let pageMinId = getMinChatLogId(data.friendChatLogData.msglist);
          if (pageMinId < minId) {
            minId = pageMinId;
          }
        }
        getFriendChatLog({
          fid: selectedAccountFriendId.value, //好友id
          limit: FETAH_SIZE, //返回记录数，默认20
          log_id: minId, //上页记录id
        });
      }
    };

    //获取最小的聊天消息ID
    function getMinChatLogId(msgList) {
      if (!msgList || msgList.length == 0) {
        return 0;
      }
      let minId = 0;
      for (var i = 0; i < msgList.length; i++) {
        let item = msgList[i];
        //排除时间类型
        if (item.msgtype == 1) {
          continue;
        }
        minId = item.id;
        break;
      }

      return minId;
    }
    //当前选中好友
    const selectedAccountFriendId = computed(() => {
      return store.state.chat_store.user_account_select_friend?.cid;
    });
    //接口正在请求的聊天记录好友ID
    const fetchingChatLogFriendId = computed(() => {
      return store.state.chat_store.fetchingChatLogFriendId;
    });
    /**
     * 对话模式，控制台模式/平台模式
     */
    const chatModel = computed(() => {
      return store.state.chat_store.chat_model;
    });

    //当前聊天账号
    const chatingAccount = computed(() => {
      return store.state.chat_store.user_account_select;
    });

    //当前选中平台
    const chatingPlatId = computed(() => {
      let chatPlatId = store.state.chat_store.chat_plat_id;
      if (chatPlatId == -1) {
        chatPlatId = store.state.chat_store.user_account_select_friend?.plat_type;
      }
      return chatPlatId;
    });
    provide("chatingPlatId", chatingPlatId);

    //当前选中账号
    const selectedAccountId = computed(() => {
      return store.state.chat_store.user_account_select?.id;
    });

    //当前聊天好友
    const chatingFriendInfo = computed(() => {
      return store.state.chat_store.user_account_select_friend;
    });

    //好友聊天记录
    const friendChatLog = computed(() => {
      if (data.friendChatLogData.fid != selectedAccountFriendId.value) {
        return { fid: 0, aid: 0, msglist: [] };
      }
      return data.friendChatLogData;
    });

    //显示消息列表
    const showChatLogList = computed(() => {
      if (data.friendChatLogData.fid != selectedAccountFriendId.value) {
        return { fid: 0, aid: 0, msglist: [] };
      }
      let allMsgList = data.friendChatLogData.msglist;
      if (allMsgList?.length > showMsgCount.value) {
        return allMsgList.slice(showMsgCount.value * -1);
      } else {
        return allMsgList;
      }
    });

    function receiveFrindChatLog(frindChatLogResp) {
      if (frindChatLogResp && frindChatLogResp.code === 1) {
        let respData = frindChatLogResp.data || {};

        if (respData?.msglist?.length > 0) {
          //存入缓存,如果有数据
          chatlogstore.refreshChatLogStoreAsyn(frindChatLogResp).then(() => {
            //通知消息变更
            bus.emit(eventbusCms.chatLogListChange, selectedAccountFriendId.value);
          });
        }

        //消息所属好友ID
        let cid = frindChatLogResp.data?.fid;
        if (cid === selectedAccountFriendId.value) {
          store.commit("chat_store/setFetchingChatLogFriendId", 0);
          //是否有更多数据
          if (respData.msglist?.length == 0) {
            //没有更多数据了
            data.chatLogNoMore = true;
            //通知没有更多
            bus.emit(eventbusCms.chatLogListNomore, selectedAccountFriendId.value);
            //10秒后释放
            //  setTimeout(() => {
            //   data.chatLogNoMore = false
            //  }, 10000);
          }

          data.friendChatLogData.aid = respData.aid;
          data.friendChatLogData.fid = respData.fid;
          //获取聊天记录,并合并
          chatlogstore.refreshChatMessage(
            data.friendChatLogData.msglist,
            respData.msglist,
            frindChatLogResp.type,
          );

          //如果来源空号检测
          let { from_type, sc } = frindChatLogResp;
          if (from_type == 14) {
            respData.sc = sc;
            bus.emit(eventbusCms.contact_check_change, respData);
            return;
          }

          data.friendChatLogData.msglist.push({ temp: true });
          //页面不刷新临时解决办法
          let delteIndex = data.friendChatLogData.msglist.findIndex((item) => item.temp == true);
          data.friendChatLogData.msglist.splice(delteIndex, 1);
          //data.friendChatLogData.msglist = mergedChatLogMsgList;
          setTimeout(() => {
            nextTick(() => {
              imgLoaded(scrollRef);
            });
          }, 10);
        }
      }
    }

    //选中好友变动
    function onSelectFriendChange(cid) {
      // console.log('~~~~~~~~~~~~~~~~~~~~~onSelectFriendChange', cid)

      store.commit("chat_store/setFetchingChatLogFriendId", cid);
      data.chatLogNoMore = false;
      initAndFetchChatLog(cid);
      //重新初始化页面显示条数
      showMsgCount.value = DEFAULT_SHOW_NUM;
    }

    //获取聊天数据
    function initAndFetchChatLog(cid) {
      //先本地初始化
      initChatLogFromLocalStoreMsg(cid);
      //获取消息
      getFriendChatLog({
        fid: cid, //好友id
        limit: FETAH_SIZE, //返回记录数，默认20
        log_id: 0, //上页记录id
      });
      //获取好友的线索信息
      getFriendClue({ fid: cid });
      //通知后台消息标记为已读
      notifyFriendMsgReaded({
        fid: cid, //好友id
      });
    }

    //从本地初始化聊天记录
    function initChatLogFromLocalStoreMsg(fid) {
      let localData = chatlogstore.getChatLog(fid);
      if (!localData) {
        data.friendChatLogData.msglist = [];
      } else {
        data.friendChatLogData.fid = localData.fid;
        data.friendChatLogData.aid = localData.aid;
        data.friendChatLogData.msglist = localData.msglist;
      }
    }

    const isReadValue = (value) => {
      return value === true || value === 1 || value === "1";
    };

    const isSelfMessage = (msgItem) => {
      return msgItem?.isme === true || msgItem?.isme == 1;
    };

    const findMessageIndex = (msgList, msgItem) => {
      if (!msgList || !msgItem) {
        return -1;
      }
      if (msgItem.s_uuid) {
        return msgList.findIndex((item) => item.s_uuid == msgItem.s_uuid);
      }
      if (msgItem.id) {
        return msgList.findIndex((item) => item.id == msgItem.id);
      }
      return -1;
    };

    const handleMsgReadStatusChange = (readMsgItem) => {
      if (isBackfillingReadStatus.value) {
        return;
      }
      if (!isReadValue(readMsgItem?.is_read)) {
        return;
      }
      let msgList = data.friendChatLogData.msglist || [];
      let readIndex = findMessageIndex(msgList, readMsgItem);
      if (readIndex <= 0 || !isSelfMessage(msgList[readIndex])) {
        return;
      }
      isBackfillingReadStatus.value = true;
      let minIndex = Math.max(0, readIndex - READ_RECEIPT_BACKFILL_LIMIT);
      for (let i = readIndex - 1; i >= minIndex; i--) {
        if (isSelfMessage(msgList[i])) {
          msgList[i].is_read = 1;
        }
      }
      nextTick(() => {
        isBackfillingReadStatus.value = false;
      });
    };

    const preloadImages = (arr) => {
      let loadedCount = 0;
      let imgs = [];
      return new Promise(function (resolve, reject) {
        for (let i = 0; i < arr.length; i++) {
          imgs[i] = new Image();
          imgs[i].src = arr[i];
          imgs[i].onload = function () {
            loadedCount++;
            if (loadedCount == arr.length) {
              resolve();
            }
          };
          imgs[i].onerror = function () {
            reject();
          };
        }
      });
    };
    /**
     * 图片加载完成，聊天信息滚到最底部
     */
    const imgLoaded = (ref) => {
      //scrollBottom(ref);
      let msgBox = ref.value?.$el;
      if (msgBox) {
        let imgs = msgBox.querySelectorAll("img");
        if (imgs) {
          let arr = [];
          for (let i = 0; i < imgs.length; i++) {
            arr[i] = imgs[i].src;
          }
          preloadImages(arr)
            .then(() => {
              scrollBottom(ref);
            })
            .catch(function () {
              scrollBottom(ref);
            });
        }
      }
    };
    /** 滚动条到底部
     */
    const scrollBottom = (ref) => {
      let viewport = ref.value;
      //如果是滚动到顶部事件触发的就不滚动到底部了
      if (data.scrollToTop) {
        data.scrollToTop = false;
        viewport.setScrollTop(100);
        return;
      }
      if (viewport) {
        viewport.setScrollTop(innerRef.value?.clientHeight);
      }
    };
    const handleMsgClicked = (e) => {
      let target = e.target;
      if (target.tagName === "A") {
        e.preventDefault();
        v3layer({
          type: "iframe",
          title: '<i class="iconfont icon-link"></i> 网址预览',
          content: target.href,
          opacity: 0.2,
          area: ["860px", "600px"],
          xclose: true,
          resize: true,
          maximize: true,
        });
      }
      // 图片
      if (target.tagName === "IMG" && target.classList.contains("img-view")) {
        //  ...
      }
    };
    // 显示表情框
    const handleEmojView = () => {
      data.showEmojView = true;
      function hideEmojView() {
        data.showEmojView = false;
        document.body.removeEventListener("click", hideEmojView);
      }
      document.body.addEventListener("click", hideEmojView);
    };

    const handleEditorClick = () => {
      // console.log('点击编辑器')
      data.isShowFootBar = false;
    };
    // 编辑器获取焦点
    const handleEditorFocus = () => {
      // console.log('编辑器获取焦点')
    };
    // 编辑器失去焦点
    const handleEditorBlur = () => {
      // console.log('编辑器失去焦点')
    };
    const handleEditorPaste = (img) => {
      let msgLs = data.groupLs.msglist;
      let len = msgLs.length;
      // 消息队列
      let arrLS = {
        id: `msg${++len}`,
        msgtype: 5,
        isme: true,
        //avatar: require("@/assets/img/uimg/img-avatar01.jpg"),
        author: "Andy",
        msg: "",
        imgsrc: img,
        videosrc: "",
      };
      msgLs = msgLs.concat(arrLS);
      data.groupLs.msglist = msgLs;
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };
    // 点击表情
    const handleEmojClicked = (e) => {
      let faceimg = e.target.cloneNode(true);
      editorRef.value.insertHtmlAtCursor(faceimg);
      data.showEmojView = false;
    };
    const handleEmojGifClicked = (path) => {
      let msgLs = data.groupLs.msglist;
      let len = msgLs.length;
      // 消息队列
      let arrLS = {
        id: `msg${++len}`,
        msgtype: 4,
        isme: true,
        //avatar: require("@/assets/img/uimg/img-avatar01.jpg"),
        author: "Andy",
        msg: "",
        imgsrc: path,
        videosrc: "",
      };
      msgLs = msgLs.concat(arrLS);
      data.groupLs.msglist = msgLs;
      data.showEmojView = false;
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };
    // 发送消息
    const isEmpty = (html) => {
      html = html.replace(/<br[\s/]{0,2}>/gi, "\r\n");
      html = html.replace(/<[^img].*?>/gi, "");
      html = html.replace(/&nbsp;/gi, "");
      return html.replace(/\r\n|\n|\r/, "").replace(/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g, "") == "";
    };
    const transferHTML = (html) => {
      let reg = /(http:\/\/|https:\/\/)((\w|#|=|\?|\.|\/|&|-)+)/g;
      return html.replace(reg, "<a href='$1$2'>$1$2</a>");
    };

    const handleMsgTextEvent = async (event) => {
      if (event.keyCode == 13) {
        if (!event.ctrlKey) {
          event.preventDefault();
          handleSubmit();
        } else {
          data.editorText += "\n";
        }
      }
    };

    const limitImageCheck = (cahtPlatId) => {
      if (!cahtPlatId) {
        return true;
      }
      let limitPlat = ["1"];
      if (limitPlat.includes(cahtPlatId + "")) {
        ElMessage.error("暂时不支持自定义图片消息，请选择审核通过的图片素材发送");
        return false;
      }
      return true;
    };

    //发送名片消息
    const handleSendCard = (cardInfo) => {
      let avatar = chatingAccount.value.avatar;
      let author = chatingAccount.value.username;
      if (chatModel.value == 2) {
        author = chatingFriendInfo.value?.account_nickname;
        avatar = chatingFriendInfo.value?.account_avatar;
      }
      let sendMsgData = {
        fid: selectedAccountFriendId.value,
        avatar,
        author,
        msgtype: 8,
        send_status: 2,
        isme: true,
        msg: cardInfo,
        s_uuid: uuidv4(),
      };

      //发送消息
      sendMsg(sendMsgData);
      //添加到本地消息
      data.friendChatLogData.msglist.push(sendMsgData);
      chatlogstore.pushSendMsgeStore(sendMsgData);

      // 清空文本框内容
      nextTick(() => {
        data.editorText = "";
        editorRef.value.focus();
      });
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };
    //发送一键留资消息
    const handleSendOneKeyCard = (cardInfo) => {
      let avatar = chatingAccount.value.avatar;
      let author = chatingAccount.value.username;
      if (chatModel.value == 2) {
        author = chatingFriendInfo.value?.account_nickname;
        avatar = chatingFriendInfo.value?.account_avatar;
      }
      let sendMsgData = {
        fid: selectedAccountFriendId.value,
        avatar,
        author,
        msgtype: 7,
        send_status: 2,
        isme: true,
        msg: cardInfo,
        s_uuid: uuidv4(),
      };

      let sendData = { ...sendMsgData, msg: cardInfo.reply_id };
      //发送消息
      sendMsg(sendData);
      //添加到本地消息
      data.friendChatLogData.msglist.push(sendMsgData);
      chatlogstore.pushSendMsgeStore(sendMsgData);

      // 清空文本框内容
      nextTick(() => {
        data.editorText = "";
        editorRef.value.focus();
      });
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };

    //预发送消息
    const handlePreSendMessage = async (msg) => {
      data.editorText = msg + "";
      editorRef.value.focus();
    };

    //发送消息
    const handleSendMessage = (simpleMessageInfo) => {
      // console.log('-------------------------handleSendMessage',simpleMessageInfo)
      let avatar = chatingAccount.value.avatar;
      let author = chatingAccount.value.username;
      if (chatModel.value == 2) {
        author = chatingFriendInfo.value?.account_nickname;
        avatar = chatingFriendInfo.value?.account_avatar;
      }
      let sendMsgItem = {
        msgtype: simpleMessageInfo.msgtype,
        fid: selectedAccountFriendId.value,
        avatar,
        author,
        send_status: 2,
        isme: true,
        s_uuid: simpleMessageInfo.s_uuid,
      };
      //消息类型:1 时间类型，2 通知类型，3 文本消息 ，5图片
      if (simpleMessageInfo.msgtype == 3) {
        sendMsgItem.msg = simpleMessageInfo.value;
      } else if (simpleMessageInfo.msgtype == 5) {
        sendMsgItem.msg = simpleMessageInfo.value;
        sendMsgItem.imgsrc = simpleMessageInfo.value;
      } else if (simpleMessageInfo.msgtype == 8) {
        let { title, sub_title } = simpleMessageInfo.value;
        sendMsgItem.msg = {
          title,
          sub_title,
          cover_img: simpleMessageInfo.value.cover_img,
        };
      }

      //消息安全检测
      if (sendMsgItem.msgtype == 3) {
        let result = securityUtils.sendMsgCheck(sendMsgItem.msg, chatingPlatId.value);
        if (!result) {
          return;
        }
      } else if (sendMsgItem.msgtype == 5) {
        if (!limitImageCheck(chatingPlatId.value)) {
          return;
        }
      }
      let sendData = sendMsgItem;
      if (simpleMessageInfo.msgtype == 8) {
        sendData = {
          ...sendMsgItem,
          msg: simpleMessageInfo.send_value || simpleMessageInfo.value?.id,
        };
      }

      //发送消息
      sendMsg(sendData);
      //添加到本地消息
      data.friendChatLogData.msglist.push(sendMsgItem);
      chatlogstore.pushSendMsgeStore(sendMsgItem);
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };

    const handleSubmit = () => {
      if (isEmpty(data.editorText)) return;
      // let arrLS = {
      //   id: `msg${++len}`,
      //   msgtype: 3,
      //   isme: true,
      //   avatar: require("@/assets/img/uimg/img-avatar01.jpg"),
      //   author: "Andy",
      //   msg: transferHTML(data.editorText),
      //   imgsrc: "",
      //   videosrc: "",
      // };
      let avatar = chatingAccount.value.avatar;
      let author = chatingAccount.value.username;
      if (chatModel.value == 2) {
        author = chatingFriendInfo.value?.account_nickname;
        avatar = chatingFriendInfo.value?.account_avatar;
      }

      // console.log(chatingAccount)
      let sendMsgData = {
        fid: selectedAccountFriendId.value,
        avatar,
        author,
        msgtype: 3,
        send_status: 2,
        isme: true,
        msg: transferHTML(data.editorText),
        s_uuid: uuidv4(),
      };

      //消息安全检测
      if (sendMsgData.msgtype == 3) {
        let result = securityUtils.sendMsgCheck(sendMsgData.msg, chatingPlatId.value);
        if (!result) {
          return;
        }
      }
      //发送消息
      sendMsg(sendMsgData);
      //添加到本地消息
      data.friendChatLogData.msglist.push(sendMsgData);
      chatlogstore.pushSendMsgeStore(sendMsgData);

      // 清空文本框内容
      nextTick(() => {
        data.editorText = "";
        editorRef.value.focus();
      });
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };

    // 选择视频
    const handleChooseVideo = () => {
      let msgLs = data.groupLs.msglist;
      let len = msgLs.length;
      let arrLS = {
        id: `msg${++len}`,
        msgtype: 6,
        isme: true,
        //avatar: require("@/assets/img/uimg/img-avatar01.jpg"),
        author: "Andy",
        msg: "",
        imgsrc: "",
        videosrc: "",
      };
      let file = pickVideoRef.value.files[0];
      if (!file) return;
      let size = Math.floor(file.size / 1024);
      if (size > 5 * 1024) {
        v3layer({ content: "请选择5MB以内的视频！" });
        return false;
      }
      // 获取视频地址
      let videoUrl;
      if (window.createObjectURL != undefined) {
        videoUrl = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        videoUrl = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        videoUrl = window.webkitURL.createObjectURL(file);
      }
      let $video = document.createElement("video");
      $video.src = videoUrl;
      $video.autoplay = true;
      $video.play();
      $video.muted = true;
      $video.addEventListener("timeupdate", () => {
        if ($video.currentTime > 0.1) {
          $video.pause();
        }
      });
      $video.addEventListener("loadeddata", function () {
        setTimeout(() => {
          var canvas = document.createElement("canvas");
          canvas.width = $video.videoWidth * 0.8;
          canvas.height = $video.videoHeight * 0.8;
          canvas.getContext("2d").drawImage($video, 0, 0, canvas.width, canvas.height);
          arrLS.imgsrc = canvas.toDataURL("image/png");
          arrLS.videosrc = videoUrl;
          msgLs = msgLs.concat(arrLS);
          data.groupLs.msglist = msgLs;

          nextTick(() => {
            imgLoaded(scrollRef);
          });
        }, 16);
      });
    };
    // 播放视频
    const handleVideoPlayed = (item) => {
      data.isShowVideoPlayer = true;
      data.videoList = item;
      nextTick(() => {
        playerRef.value.play();
      });
    };
    // 右键：消息
    const handleMsgCtxMenu = (e, index) => {
      let points = [e.clientX, e.clientY];
      //let msgLs = data.groupLs.msglist;
      console.log(index);
      let $el = v3layer({
        type: "contextmenu",
        opacity: 0,
        follow: points,
        btns: [
          { text: "复制" },
          { text: "发送给好友" },
          { text: "转发" },
          { text: "收藏" },
          {
            text: "删除",
            click: () => {
              // msgLs.splice(index, 1);
              // data.groupLs.msglist = msgLs;
              $el.close();
            },
          },
        ],
      });
    };
    const handleDragEnter = (e) => {
      e.stopPropagation();
      e.preventDefault();
    };
    const handleDragOver = (e) => {
      e.stopPropagation();
      e.preventDefault();
    };
    const handleDrop = (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleFileList(e.dataTransfer);
    };
    // 获取拖拽文件列表
    const handleFileList = (filelist) => {
      let files = filelist.files;
      if (files.length >= 2) {
        v3layer.message({
          icon: "error",
          content: "暂时支持拖拽一张图片",
          shade: true,
          layerStyle: { background: "#ffefe6", color: "#ff3838" },
        });
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        if (files[i].type != "") {
          handleFileAdd(files[i]);
        } else {
          v3layer.message({
            icon: "error",
            content: "目前不支持文件夹拖拽功能",
            shade: true,
            layerStyle: { background: "#ffefe6", color: "#ff3838" },
          });
        }
      }
    };
    const handleFileAdd = (file) => {
      let msgLs = data.groupLs.msglist;
      let len = msgLs.length;
      let arrLS = {
        id: `msg${++len}`,
        msgtype: 5,
        isme: true,
        avatar: require("@assets/img/uimg/img-avatar08.jpg"),
        author: "Andy",
        msg: "",
        imgsrc: "",
        videosrc: "",
      };
      if (file.type.indexOf("image") == -1) {
        v3layer.message({
          icon: "error",
          content: "目前不支持非图片拖拽功能",
          shade: true,
          layerStyle: { background: "#ffefe6", color: "#ff3838" },
        });
      } else {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          let img = this.result;
          arrLS.imgsrc = img;
          msgLs = msgLs.concat(arrLS);
          data.groupLs.msglist = msgLs;
          nextTick(() => {
            imgLoaded(scrollRef);
          });
        };
      }
    };

    // 提示信息
    const handleTipsLayer = (e) => {
      let pos = [e.clientX + 25, e.clientY - 110];
      v3layer.popover({
        icon: "info",
        title: "Tips",
        content:
          '<div class="pb-10">发送消息快捷键:<b class="bg-00e077 c-fff">Enter</b> <br/> 消息换行快捷键 <b class="bg-00e077 c-fff">Ctrl+Enter</b> </div>',
        follow: pos,
        shade: true,
        opacity: 0.2,
      });
    };

    const handleScreenShot = () => {};

    // 窗口抖动
    const handleScreenShake = () => {
      let ntbox = document.querySelector(".vui__wrapper");
      ntbox.classList.add("shake");
      setTimeout(() => {
        ntbox.classList.remove("shake");
      }, 1000);
    };

    //选中表情
    const handleAddFace = (item) => {
      let content = data.editorText;
      if (content) {
        let oldContentLength = content.length;
        content = `${content.substring(0, data.focusIndex)}[${item.title}]${content.substring(
          data.focusIndex,
          content.length,
        )}`;
        data.focusIndex += content.length - oldContentLength;
      } else {
        content = `[${item.title}]`;
        data.focusIndex += content.length;
      }
      data.editorText = content;
    };

    const handleSaveFocusIndex = () => {
      data.focusIndex = editorRef.value.selectionStart;
    };

    // 按 CTRL + 回车发送信息
    const handleOnKeyup = (e) => {
      // var keyCode = e.keyCode || e.which;
      // if (e.ctrlKey && keyCode === 13) {
      //   handleSubmit();
      //   e.preventDefault();
      //   return false;
      // }
    };

    //显示图片上传窗口
    const handleChooseImageVisiable = () => {
      if (!limitImageCheck(chatingPlatId.value)) {
        return;
      }

      //console.log(data.previewImg)
      data.preview = true;

      //立即执行token刷新
      store.dispatch("qiniu/refreshToken");
    };

    //选中图片
    const handleChooseImage0 = (file) => {
      data.previewImg = URL.createObjectURL(file.raw);
      let img =
        '<img src="' +
        data.previewImg +
        '" alt="" style="vertical-align: middle; width: 200px; height: 200px" />';
      data.uploadImageText = img;
    };

    //清理文件上传信息
    const handleClearUploadInfo = () => {
      data.imageSendLoading = false;
      data.preview = false;
      data.previewImg = "";
      data.uploadFileList = [];
      uploadImageDivRef.value.innerHTML = "";
    };

    const handleUploadBefore = (file) => {
      data.imageSendLoading = false;
      let tokenInfo = store.getters["qiniu/getTokenInfo"];
      if (!tokenInfo?.token) {
        store.dispatch("qiniu/refreshToken");
        ElMessage.error("图片服务器繁忙，请稍后重试");
        data.preview = false;
        data.previewImg = "";
        return false;
      }

      data.progress = 0;
      if (data.maxPictureSize * 1024 * 1024 < file.size) {
        ElMessage.error("上传图片大小不能超过 " + data.maxPictureSize + "MB!");
        data.preview = false;
        data.previewImg = "";
        return false;
      }
      return true;
    };

    const hadleUploadProgress = (e) => {
      data.progress = e.percent;
    };

    //发送图片
    const handleSendImage = () => {
      if (!data.previewImg) {
        ElMessage.warning("请选择图片");
        return;
      }
      data.imageSendLoading = true;
      uploadPictureRef.value.submit();
    };
    //发送图片数据
    const uploadImageData = computed(() => {
      return { token: store.state.qiniu.token };
    });

    //发送图片失败
    const handleUploadError = (err) => {
      console.log(err.message);
      let msg = JSON.parse(err.message);
      ElMessage.error(msg.error);
      data.imageSendLoading = false;
      nextTick(() => {
        handleClearUploadInfo();
      });
    };
    //发送图片成功
    const handleUploadSuccess = (res) => {
      nextTick(() => {
        handleClearUploadInfo();
      });

      let domain = store.state.qiniu.domain;
      if (domain?.endsWith("/")) {
        domain = domain.substring(0, domain.length - 1);
      }
      let key = res.key;
      if (key?.startsWith("/")) {
        key = key.substring(1);
      }
      let avatar = chatingAccount.value.avatar;
      let author = chatingAccount.value.username;
      if (chatModel.value == 2) {
        author = chatingFriendInfo.value?.account_nickname;
        avatar = chatingFriendInfo.value?.account_avatar;
      }

      let url = domain + "/" + key;
      let sendImageDAta = {
        fid: selectedAccountFriendId.value,
        msgtype: 5,
        send_status: 2,
        isme: true,
        avatar,
        author,
        msg: url,
        imgsrc: url,
        videosrc: "",
        s_uuid: uuidv4(),
      };

      //添加到本地消息
      data.friendChatLogData.msglist.push(sendImageDAta);
      chatlogstore.pushSendMsgeStore(sendImageDAta);

      //发送消息
      sendMsg(sendImageDAta);
      nextTick(() => {
        imgLoaded(scrollRef);
      });
    };

    const initUploadDivListener = () => {
      uploadImageDivRef.value.addEventListener("paste", function (e) {
        e.preventDefault();
        let cbd = e.clipboardData;
        let ua = window.navigator.userAgent;
        if (!(e.clipboardData && e.clipboardData.items)) return;
        if (
          cbd.items &&
          cbd.items.length === 2 &&
          cbd.items[0].kind === "string" &&
          cbd.items[1].kind === "file" &&
          cbd.types &&
          cbd.types.length === 2 &&
          cbd.types[0] === "text/plain" &&
          cbd.types[1] === "Files" &&
          ua.match(/Macintosh/i) &&
          Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
        ) {
          return;
        }
        for (var i = 0; i < cbd.items.length; i++) {
          var item = cbd.items[i];
          if (item.kind == "file") {
            var file = item.getAsFile();
            if (file.size === 0) return;
            // var reader = new FileReader();
            // reader.readAsDataURL(blob);
            data.uploadImageText = "";

            uploadPictureRef.value?.clearFiles();
            file.uid = new Date().getTime();
            uploadPictureRef.value?.handleStart(file);
            return false;
          }
        }
      });
    };
    //文件上传超出限制处理
    const handleExceed = (files) => {
      uploadPictureRef.value?.clearFiles();
      const file = files[0];
      file.uid = new Date().getTime();
      uploadPictureRef.value?.handleStart(file);
    };

    const handleUploadImageDivInput = () => {};

    //查找上一条聊天记录的聊天时间
    const handleFindUpMsgTime = (index) => {
      if (index == 0) {
        return "";
      }
      let item = friendChatLog.value.msglist[index - 1];
      return item?.send_time || "";
    };

    // 激活右侧窗口----------------------
    const handleActiveSidebarRightComponent = (componentStr) => {
      store.dispatch("sidebarRight/activeComponent", componentStr);
    };

    return {
      ...toRefs(data),
      smartEnumPlugin,
      chatingPlatId,
      innerRef,
      scrollRef,
      editorRef,
      uploadImageDivRef,
      pickImageRef,
      pickVideoRef,
      playerRef,
      chatingAccount,
      selectedAccountId,
      selectedAccountFriendId,
      chatingFriendInfo,
      friendChatLog,
      fetchingChatLogFriendId,
      qiniuUploadurl,
      uploadImageData,
      uploadPictureRef,
      showChatLogList,
      activeComponent,
      allMsgCount,
      showMsgCount,
      userInfo,
      enterpriseCardRef,
      chatModel,
      handleShowCardPage,
      initUploadDivListener,
      handleMsgClicked,
      handleEmojView,
      handleEditorClick,
      handleEditorFocus,
      handleEditorBlur,
      handleEditorPaste,
      handleEmojClicked,

      handleEmojGifClicked,
      handleMsgTextEvent,
      handleSubmit,
      handleChooseVideo,
      handleVideoPlayed,
      handleMsgCtxMenu,
      handleTipsLayer,
      handleDragEnter,
      handleDragOver,
      handleDrop,
      handleScreenShot,
      handleScreenShake,
      handleScroll,
      handleSaveFocusIndex,
      handleAddFace,
      handleOnKeyup,
      handleChooseImage0,
      handleUploadBefore,
      hadleUploadProgress,
      handleSendImage,
      handleUploadSuccess,
      handleUploadError,
      handleChooseImageVisiable,
      handleExceed,
      handleUploadImageDivInput,
      handleClearUploadInfo,
      handleFindUpMsgTime,
      handleMsgReadStatusChange,
      receiveFrindChatLog,
      onSelectFriendChange,
      handleSendMessage,
      handleActiveSidebarRightComponent,
      handleLoadMore,
      handleUseRobotStatusChange,
      handleChangeManuStatus,
      handleStartAi,
      handleSendCard,
      onekeyleadsRef,
      handleShowOnekeyLeads,
      handleSendOneKeyCard,
      getXshFileAbsPath,
      //评论
      showComment,
      handdleShowComment,
      commentListRef,
      handleShowReplyComment,
      messageInputRef,
      handleReplyComment,
      commentLoading,
      // end 评论
    };
  },
};
</script>

<style lang="scss" scoped>
.active_right_comp {
  color: #409eff;
  border: 1px solid #409eff;
}

.header_c {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  .left {
    display: flex;
    align-items: center;

    .name {
      margin-left: 10px;
      width: 350px;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
    }

    .avatar {
      width: 30px;
      height: 30px;
      overflow: hidden;
      border-radius: 100%;
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .right {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: right;
  }
}

textarea {
  box-sizing: border-box;
  height: 100%;
  line-height: 1.5;
  width: 100%;
  outline: none;
  font-family: "Micrsofot Yahei";
  resize: none;
  background-color: transparent;
}

.me_msg_ontainer {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.lds-ring {
  /* change color here */
  color: #1c4c5b;
  padding: 5px;
}

.lds-ring,
.lds-ring div {
  box-sizing: border-box;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  margin: 2px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
